/* eslint-disable */
import React, { useEffect } from "react";

import AuthHeader from "components/common/AuthHeader";
import CognifitAssessmentReport from "components/CognifitComponents/ActivityDetails/AssessmentReport";   

const CognifitActivityDetails = () => {
  useEffect(() => {
    document.title = "Cognifit | Activity Details";
  }, []);

  return (
    <>
      <AuthHeader moduleName={"cognifit"} />
      <div className="container-fluid" style={{ marginTop: "6rem" }}>
        <CognifitAssessmentReport />
      </div>
    </>
  );
};

export default CognifitActivityDetails;